import { Component, h, Prop, Event, EventEmitter } from '@stencil/core';
import { Customer } from '../../../globals/customer';
import { SubmitCartResponse } from '../../../utils/submit-cart';
import { PaymentSigningTranslation } from '../../../globals/translations';
import { SiteConfig } from '../../../globals/site-config';
import { ErrorHelper } from '../../../helpers';

@Component({
  tag: 'payment-signing-state',
  styleUrl: './state-styles/payment-signing-state.scss',
  shadow: false,
})
export class PaymentSigningState {
  @Prop() cartResponse: SubmitCartResponse;
  @Prop() cardInfo: Customer['cardInfo'];
  @Prop({ mutable: true }) errors: ErrorHelper;
  @Prop() leaseId: string;
  @Prop() retailerConfig: Partial<SiteConfig>;
  @Prop() translation: Partial<PaymentSigningTranslation>;
  @Prop() creditCardLastFour: string;

  @Event() updateCustomer: EventEmitter<Partial<Customer>>;
  @Event() continueClick: EventEmitter;

  render() {
    const { initialPayment, totalDueAtSigning, totalTax, initialPaymentTax, totalRetailerDeliveryFees, retailerDeliveryFeesTax, status } = this.cartResponse;
    const cartItems = [...this.cartResponse.items];
    const { merchantLogoUrl, defaultLogoUrl, retailerName, nonLeasableLimit } = this.retailerConfig;
    const fallbackImgUrl = merchantLogoUrl ? merchantLogoUrl : defaultLogoUrl;

    if (totalRetailerDeliveryFees) {
      cartItems.push({
        isLeasable: false,
        description: 'Delivery cost (Shipping)',
        tax: 0,
        brand: '',
        identifier: '',
        unitPrice: totalRetailerDeliveryFees,
        quantity: 1,
        category: '',
      });
    }

    const signingProps = {
      cartItems: JSON.stringify(cartItems),
      initialPayment,
      totalDueAtSigning,
      totalTax,
      initialPaymentTax,
      retailerDeliveryFeesTax,
      cardType: this.cardInfo?.cardType,
      cardNumber: this.cardInfo?.cardNumber,
      creditCardLastFour: this.creditCardLastFour,
      leaseId: this.leaseId,
      showVerifyPmtError: this.errors.hasVerifyPaymentError,
      showInvalidCardTypeError: this.errors.hasInvalidCardTypeError,
      showPmtFailedError: this.errors.hasPaymentFailedError,
      retailerName,
      status,
      nonLeasableLimit,
      fallbackItemImgUrl: fallbackImgUrl,
      translation: this.translation,
      isAvsEnabled: this.retailerConfig?.features?.CheckoutAvsFlow === true,
    };

    return <pc-payment-signing {...signingProps}>{this.errors.hasGenericError && <pc-generic-error slot="error-card" />}</pc-payment-signing>;
  }
}
